module.exports = __webpack_public_path__ + "static/media/Arrow-hover.61c8f14f.svg";